/**
 * Capitalize the first letter of each word in a string.
 *
 * @param {string} value - Raw input value.
 * @returns {string} Capitalized string.
 */
function capitalizeWords(value) {
    if (!value) return '';
    return String(value).replace(/\b\w/g, char => char.toUpperCase());
}

/**
 * Vue directive that capitalizes the first letter of each word on an input element.
 *
 * Important:
 * - Works with strings only.
 * - Dispatches a native `input` event when it mutates the value
 *   so `v-model` stays in sync.
 * - Capitalizes on every keystroke and on blur.
 *
 * @example
 * <base-input v-capitalize v-model="customer.first_name" />
 *
 * @type {Object}
 */
export default {
    bind(el) {
        const input = el.tagName === 'INPUT' ? el : el.querySelector('input');
        if (!input) return;

        input.addEventListener('input', (event) => {
            const formatted = capitalizeWords(event.target.value);
            if (formatted !== event.target.value) {
                const cursor = event.target.selectionStart;
                event.target.value = formatted;
                try {
                    event.target.setSelectionRange(cursor, cursor);
                } catch (e) {
                    // ignore for unsupported input types
                }
                event.target.dispatchEvent(new Event('input'));
            }
        });

        input.addEventListener('blur', (event) => {
            const formatted = capitalizeWords(event.target.value);
            if (formatted !== event.target.value) {
                event.target.value = formatted;
                event.target.dispatchEvent(new Event('input'));
            }
        });
    }
};
